export const TOGGLE_APP_STATE = 'TOGGLE_APP_STATE'
export const ACCESSIBILITY_REQUIRED = 'ACCESSIBILITY_REQUIRED'
export const SET_VERSION_INFO = 'SET_VERSION_INFO'
export const SET_SAF_MODE = 'SET_SAF_MODE'
export const SET_SAF_RESPONSE = 'SET_SAF_RESPONSE'
export const SET_ERROR_INFO = 'SET_ERROR_INFO'
export const SET_SAF_FORCED_BY_PLATFORM = 'SET_SAF_FORCED_BY_PLATFORM'
export const REFRESH_CACHE = 'REFRESH_CACHE'

export const toggleAppState = (newState) => ({
  payload: newState,
  type: TOGGLE_APP_STATE,
})

export const toggleAccessibilityRequired = (accessibilityRequired) => ({
  payload: accessibilityRequired,
  type: ACCESSIBILITY_REQUIRED,
})

export const setVersionInfo = (payload) => ({
  type: SET_VERSION_INFO,
  payload,
})

export const setSafMode = (payload) => ({
  type: SET_SAF_MODE,
  payload,
})

export const setSafForcedByPlatform = (payload) => ({
  type: SET_SAF_FORCED_BY_PLATFORM,
  payload,
})

export const setSafResponse = (payload) => ({
  type: SET_SAF_RESPONSE,
  payload,
})

export const setErrorInfo = (payload) => ({
  type: SET_ERROR_INFO,
  payload,
})

export const refreshCache = (shouldClearCart) => ({
  type: REFRESH_CACHE,
  shouldClearCart,
})
